module.exports = "/_next/static/images/digitalbanking-duotone-793daf2b73ce50e49fa8d60e1c2d60ee.svg";